/**
 *
 * @component 用户中心/数据看板/----项目完成率、延期周期统计
 *
 **/

import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';
import { xBarOption } from './constants';
import './ProjectStatistics.scss';

function ProjectStatistics(props) {
    const {
        defaultValue,
        baseParams = {},
        managerOpts,
        isAdmin = false,
    } = props;
    const [active, setActive] = useState(0);
    const [params, setParams] = useState({ div: 8, managerId: null });
    const [data, setData] = useState({ duty: [], finish: [] });

    const { duty, finish } = data;
    const options = {
        ...xBarOption,
        color: [active > 0 ? '#EFB353' : '#386BF6'],
        yAxis: {
            type: 'category',
            axisLabel: {
                color: 'rgba(0,0,0,0.4)',
                overflow: 'truncate',
                align: 'left',
                width: 90,
                margin: 100,
            },
            data: active > 0 ? duty.map(e => e.name) : finish.map(e => e.name),
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#F4F6FC',
                },
            },
            boundaryGap: false,
        },
        xAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: active > 0 ? '{value} 天' : '{value} %',
                    color: 'rgba(0, 0, 0, 0.5)',
                },
                splitLine: {
                    show: false,
                },
                offset: 36,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#E3E7F2',
                    },
                },
                axisTick: {
                    show: true,
                    lineStyle: {
                        color: '#E3E7F2',
                    },
                },
            },
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            // valueFormatter: value => value + (active > 0 ? '%' : '天'),
            formatter: active > 0 ? '{a} : {c}天' : '{b} : {c}%',
        },
        series: [
            {
                name: ['完成率', '延期周期'][active],
                type: 'bar',
                itemStyle: {
                    borderRadius: 6,
                },
                silent: true,
                barWidth: 11,
                lebel: {
                    show: true,
                },
                data:
                    active > 0
                        ? duty.map(e => +e.duty)
                        : finish.map(e => +e.isFinish),
            },
        ],
    };

    const canInit = !params.managerId;

    useEffect(() => {
        canInit && setData(defaultValue || { duty: [], finish: [] });
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
    }, [params]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data.getProjectDelayOrFinish || { duty: [], finish: [] });
        });
    }

    const TABS = [
        {
            name: '项目完成率',
            key: 0,
        },
        {
            name: '项目延期周期',
            key: 1,
        },
    ];

    const HISTORY = useHistory();
    const targetList = () => {
        const urlParam = new URLSearchParams('');
        params.managerId && urlParam.append('manager', params.managerId);
        +active === 1 && urlParam.append('status', 4);

        const path = isAdmin
            ? '/user-center/administrator/status-list?' + urlParam.toString()
            : '/user-center/manager/status-list?' + urlParam.toString();
        HISTORY.push(path);
    };

    const more = (
        <>
            <Select
                onChange={e => onChange(e, 'managerId')}
                className="manager-select"
                showSearch
                filterOption={(input, option) =>
                    (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                }
                options={managerOpts}
                value={params.managerId}></Select>
            <span onClick={targetList} className="type--normal native-link">
                {intl.get('base.viewMore')}
            </span>
        </>
    );
    const isEmpty = active > 0 ? !duty.length : !finish.length;
    return (
        <BaseCard
            className="project-statistics"
            tabsProps={{ onChange: setActive }}
            tabs={TABS}
            headerExtra={more}>
            {isEmpty ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <ECharts height="19.75rem" option={options}></ECharts>
            )}
        </BaseCard>
    );
}

export default ProjectStatistics;
